import React from "react";
import { Route, Routes } from "react-router-dom";
import Dashboard from "layouts/dashboard";
import Tables from "layouts/tables";
import Members from "layouts/members";
import Branch from "layouts/branch";
import Machine from "layouts/machine";
import MachineEdit from "layouts/machine/edit";
import BranchInsert from "layouts/branch/insert";
import BranchEdit from "layouts/branch/edit";
import Points from "layouts/points";
import Grinds from "layouts/grinds";
import Profile from "layouts/profile";
import Memberdetail from "layouts/members/memberdetail";
import MemberEdit from "layouts/members/memberedit";
import SignIn from "layouts/authentication/sign-in";
import SignOut from "layouts/authentication/sign-out";

import Boards from "layouts/boards/";
import BoardDetail from "layouts/boards/boarddetail";
import BoardEdit from "layouts/boards/boardedit";
import BoardInsert from "layouts/boards/boardinsert";
import Config from "layouts/config";
import PrivateRoute from "./PrivateRoute"; // PrivateRoute 컴포넌트를 임포트합니다.
import Icon from "@mui/material/Icon";
import RTL from "layouts/rtl";
import Collect from "layouts/collect";
import SPoint from "layouts/spoint";
import MToken from "layouts/mtoken";
import Gift from "layouts/gift";
import SocialPosts from "layouts/social-posts";
import Cafe24Point from "layouts/cafe24-point";
import MemberAdd from "layouts/members/memberadd";
import BranchGrindUsers from "layouts/members/branch-grind-users";
import BannerManagement from "layouts/banner";
import ZeroSalonItemManagement from "layouts/zerosalon-items";
import KeitiIncentiveList from "layouts/keiti-incentive";
import Cafe24Health from "layouts/cafe24-health";

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <PrivateRoute element={<Dashboard />} />,
  },
  {
    type: "collapse",
    name: "회원관리",
    key: "members",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/members",
    component: <PrivateRoute element={<Members />} />,
  },
  {
    type: "collapse",
    name: "지점별 회원관리",
    key: "branch-grind-users",
    icon: <Icon fontSize="small">group</Icon>,
    route: "/members/branch-grind-users",
    component: <PrivateRoute element={<BranchGrindUsers />} />,
  },
  // 다른 라우트들도 PrivateRoute를 사용하여 보호합니다.
  {
    type: "collapse",
    name: "지점",
    key: "branch",
    icon: <Icon fontSize="small">domain</Icon>,
    route: "/branch",
    component: <PrivateRoute element={<Branch />} />,
  },
  {
    type: "route",
    name: "지점등록",
    key: "branchinsert",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/branch/insert",
    component: <PrivateRoute element={<BranchInsert />} />,
  },
  {
    type: "route",
    name: "지점수정",
    key: "branchedit",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/branch/edit",
    component: <PrivateRoute element={<BranchEdit />} />,
  },
  {
    type: "collapse",
    name: "기기관리",
    key: "machine",
    icon: <Icon fontSize="small">dvr</Icon>,
    route: "/machine",
    component: <PrivateRoute element={<Machine />} />,
  },
  {
    type: "route",
    name: "기기수정",
    key: "machineedit",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/machine/edit",
    component: <PrivateRoute element={<MachineEdit />} />,
  },
  {
    type: "collapse",
    name: "회수요청",
    key: "collect",
    icon: <Icon fontSize="small">delete</Icon>,
    route: "/collect",
    component: <PrivateRoute element={<Collect />} />,
  },
  {
    type: "collapse",
    name: "포인트관리",
    key: "points",
    icon: <Icon fontSize="small">attach_money</Icon>,
    route: "/point",
    component: <PrivateRoute element={<Points />} />,
  },
  {
    type: "collapse",
    name: "쇼핑포인트전환",
    key: "spoint",
    icon: <Icon fontSize="small">shopping_cart_checkout</Icon>,
    route: "/spoint",
    component: <PrivateRoute element={<SPoint />} />,
  },
  {
    type: "collapse",
    name: "제로살롱몰포인트전환",
    key: "cafe24-point",
    icon: <Icon fontSize="small">currency_exchange</Icon>,
    route: "/cafe24-point",
    component: <PrivateRoute element={<Cafe24Point />} />,
  },
  {
    type: "collapse",
    name: "환경토큰전환",
    key: "mtoken",
    icon: <Icon fontSize="small">park</Icon>,
    route: "/mtoken",
    component: <PrivateRoute element={<MToken />} />,
  },
  {
    type: "collapse",
    name: "기프티콘히스토리",
    key: "gift",
    icon: <Icon fontSize="small">park</Icon>,
    route: "/gift",
    component: <PrivateRoute element={<Gift />} />,
  },
  {
    type: "collapse",
    name: "분쇄량",
    key: "grinds",
    icon: <Icon fontSize="small">inbox</Icon>,
    route: "/grind",
    component: <PrivateRoute element={<Grinds />} />,
  },
  {
    type: "collapse",
    name: "게시물관리",
    key: "boards",
    icon: <Icon fontSize="small">announcement</Icon>,
    route: "/boards",
    component: <PrivateRoute element={<Boards />} />,
  },
  {
    type: "collapse",
    name: "전체 지점 포스팅 관리",
    key: "social-posts",
    icon: <Icon fontSize="small">share</Icon>,
    route: "/social-posts",
    component: <PrivateRoute element={<SocialPosts />} />,
  },
  {
    type: "collapse",
    name: "배너이미지 관리",
    key: "banner",
    icon: <Icon fontSize="small">image</Icon>,
    route: "/banner",
    component: <PrivateRoute element={<BannerManagement />} />,
  },
  {
    type: "collapse",
    name: "제로살롱몰 상품 관리",
    key: "zerosalon-items",
    icon: <Icon fontSize="small">shopping_bag</Icon>,
    route: "/zerosalon-items",
    component: <PrivateRoute element={<ZeroSalonItemManagement />} />,
  },
  {
    type: "collapse",
    name: "제로살롱몰 연동",
    key: "cafe24-health",
    icon: <Icon fontSize="small">sync_alt</Icon>,
    route: "/cafe24-health",
    component: <PrivateRoute element={<Cafe24Health />} />,
  },
  {
    type: "collapse",
    name: "탄소중립 인센티브",
    key: "keiti-incentive",
    icon: <Icon fontSize="small">eco</Icon>,
    route: "/keiti-incentive",
    component: <PrivateRoute element={<KeitiIncentiveList />} />,
  },
  {
    type: "collapse",
    name: "환경설정",
    key: "config",
    icon: <Icon fontSize="small">settings</Icon>,
    route: "/config",
    component: <PrivateRoute element={<Config />} />,
  },
  {
    type: "collapse",
    name: "로그아웃",
    key: "sign-out",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/authentication/sign-out",
    component: <SignOut />,
  },
  {
    type: "route",
    name: "Sign In",
    key: "sign-in",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/authentication/sign-in",
    component: <SignIn />,
  },
  {
    type: "route",
    name: "Member",
    key: "Member",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/memberdetail",
    component: <PrivateRoute element={<Memberdetail />} />,
  },
  {
    type: "route",
    name: "MemberEdit",
    key: "MemberEdit",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/member/edit",
    component: <PrivateRoute element={<MemberEdit />} />,
  },
  {
    type: "route",
    name: "BoardEdit",
    key: "BoardEdit",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/board/edit/:id",
    component: <PrivateRoute element={<BoardEdit />} />,
  },
  {
    type: "route",
    name: "BoardInsert",
    key: "BoardInsert",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/board/insert/",
    component: <PrivateRoute element={<BoardInsert />} />,
  },
  {
    type: "route",
    name: "BoardDetail",
    key: "BoardDetail",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/board/detail/:id",
    component: <PrivateRoute element={<BoardDetail />} />,
  },

  {
    type: "route",
    name: "MemberAdd",
    key: "MemberAdd",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/member/add",
    component: <PrivateRoute element={<MemberAdd />} />,
  },
 

];

export default routes;
